const urlTo = (url, type) => {
  try {
    const parsedUrl = new URL(url)
    const pathname = parsedUrl.pathname
    const fileName = pathname.split('/').pop() || ''
    const [baseName, extension] = fileName.split(/\.(?=[^\.]+$)/)

    switch (type) {
      case 'fileName':
        return fileName

      case 'title':
        return baseName
          .replace(/[-_]+/g, ' ')        // turn dashes/underscores into spaces
          .replace(/\s+/g, ' ')          // collapse multiple spaces
          .replace(/\b\w/g, c => c.toUpperCase()) // title case
          .trim()

      case 'extension':
        return extension ? extension.toLowerCase() : ''

      case 'contentType':
        if (!extension) return ''
        const mimeMap = {
          jpg: 'image/jpeg',
          jpeg: 'image/jpeg',
          png: 'image/png',
          gif: 'image/gif',
          webp: 'image/webp',
          svg: 'image/svg+xml',
          pdf: 'application/pdf',
          txt: 'text/plain',
          md: 'text/markdown',
          json: 'application/json',
          mp4: 'video/mp4',
          mov: 'video/quicktime',
          webm: 'video/webm',
          avi: 'video/x-msvideo'
        }
        return mimeMap[extension.toLowerCase()] || 'application/octet-stream'

      case 'type':
        if (!extension) return ''
        const imageExts = ['jpg', 'jpeg', 'png', 'gif', 'webp', 'svg', 'avif', 'tiff']
        const videoExts = ['mp4', 'mov', 'webm', 'avi', 'mkv']
        const extLower = extension.toLowerCase()
        if (imageExts.includes(extLower)) return 'image'
        if (videoExts.includes(extLower)) return 'video'
        return extLower

      default:
        return ''
    }
  } catch (e) {
    return ''
  }
}

export default urlTo
